<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar @search="onFilter" @focus="onFocusChange" placeholder="输入现金流量名称查找" ref="searchBar" />
    </template>
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in filteredItems"
          :key="item.itemCode"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.itemName}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";

export default {
  components: {
    PickerField,
    SearchBar
  },
  props: {
    label: {
      type: String,
      default: "现金流量项"
    },
    value: String
  },
  data() {
    return {
      isFocus: false,
      items: [],
      filteredItems: []
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.itemName);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/finance/cashflow/list"
      }).then(function(res) {
        if (res.success) {
          me.items = res.data;
          me.onFilter();
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    /**
     * cashflow接口没有筛选功能，直接本地过滤
     */
    onFilter() {
      var me = this,
        items = me.items,
        keyword = me.$refs.searchBar.getValue();
      if (items && keyword) {
        me.filteredItems = items.filter(
          item => item.itemName.indexOf(keyword) > -1
        );
      } else {
        me.filteredItems = items;
      }
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>